import { cn as e } from "../../shared/utils.js";
import { getAvatarColorIndex as t } from "./utils.js";
import { AvatarIcon as n } from "@systemeio/icons";
import { forwardRef as r } from "react";
import { jsx as i } from "react/jsx-runtime";
import { cva as a } from "class-variance-authority";
import { Avatar as o } from "@base-ui/react/avatar";
//#region src/avatar/primitive/index.tsx
var s = a("inline-flex shrink-0 select-none items-center justify-center overflow-hidden align-middle rounded-full", {
	variants: { size: {
		md: "size-6 text-xs",
		lg: "size-10 text-base",
		xl: "size-14 text-lg"
	} },
	defaultVariants: { size: "lg" }
}), c = r(({ className: t, size: n, ...r }, a) => /* @__PURE__ */ i(o.Root, {
	ref: a,
	className: e(s({ size: n }), t),
	...r
})), l = r(({ className: t, ...n }, r) => /* @__PURE__ */ i(o.Image, {
	ref: r,
	className: e("size-full object-cover", t),
	...n
})), u = r(({ className: r, children: a, initials: s, color: c, ...l }, u) => {
	let d = s || a, f = !d, p = f ? "placeholder" : c ?? t(typeof d == "string" ? d : "") ?? 0;
	return /* @__PURE__ */ i(o.Fallback, {
		ref: u,
		className: e("flex size-full items-center justify-center font-medium", "data-[color=placeholder]:bg-bg-quaternary", "data-[color=\"0\"]:bg-bg-tertiary data-[color=\"0\"]:text-text-secondary", "data-[color=\"1\"]:bg-palette-light-blue-palette-lightblue-bg data-[color=\"1\"]:text-palette-light-blue-palette-lightblue-textandicon", "data-[color=\"2\"]:bg-palette-success-palette-green-bg data-[color=\"2\"]:text-palette-success-palette-green-textandicon", "data-[color=\"3\"]:bg-palette-error-palette-red-bg data-[color=\"3\"]:text-palette-error-palette-red-textandicon", "data-[color=\"4\"]:bg-palette-warning-palette-yellow-bg data-[color=\"4\"]:text-palette-warning-palette-yellow-textandicon", "data-[color=\"5\"]:bg-palette-purple-bg data-[color=\"5\"]:text-palette-purple-textandicon", "data-[color=\"6\"]:bg-palette-teal-bg data-[color=\"6\"]:text-palette-teal-textandicon", "data-[color=\"7\"]:bg-palette-blue-bg data-[color=\"7\"]:text-palette-blue-textandicon", r),
		"data-color": p,
		...l,
		children: f ? /* @__PURE__ */ i(n, { className: "text-icon-on size-full" }) : s || a
	});
});
c.displayName = o.Root.displayName, l.displayName = o.Image.displayName, u.displayName = o.Fallback.displayName;
var d = {
	Root: c,
	Image: l,
	Fallback: u
};
//#endregion
export { d as AvatarPrimitive, s as avatarRootVariants };
